import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SUB_BASIC_01_Schema } from './SUB_BASIC_01_Schema';

/**
 * 도급사업관리 기본정보(SUB_BASIC_01) 관련 React Query 훅 모음
 * - 기본 조회(useQuery): useSearch1, useSearch2, useSearch3
 *
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 */

// 협력업체 기본 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SUB_BASIC_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['SubcontractorManagement', 'getSubBasic01R1', params],
    queryFn: () =>
      apiRequest(
        'post',
        Global.urls.SubcontractorManagement.getSubBasic01R1,
        params
      ),
    enabled: true, // 자동 실행
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

// 수급업체 평가표 목록 조회
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      SUB_BASIC_01_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SubcontractorManagement.getSubBasic01MstR1,
      encryptedParams
    );
  }, successOptions);
};

// 수급업체 평가표 상세 조회
export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      SUB_BASIC_01_Schema.mapper.search3,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SubcontractorManagement.getSubBasicMst01R2,
      encryptedParams
    );
  }, successOptions);
};

// 협력업체 삭제
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SUB_BASIC_01_Schema.mapper.delete1);

    return apiRequest(
      'post1',
      Global.urls.SubcontractorManagement.deleteSubBasic01D1,
      payload
    );
  }, options);
};

// 수급업체 평가표 삭제
export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (rows, context) => {
    const payload = mapRowsBySchema(rows, SUB_BASIC_01_Schema.mapper.delete2);

    return apiRequest(
      'post1',
      Global.urls.SubcontractorManagement.deleteSubBasic01MstD1,
      payload
    );
  }, options);
};

// 협력업체 저장
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SUB_BASIC_01_Schema.mapper.save1);

    return apiRequest(
      'post1',
      Global.urls.SubcontractorManagement.saveSubBasic01U1,
      payload
    );
  }, options);
};

// 수급업체 평가표 저장
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SUB_BASIC_01_Schema.mapper.save2);

    return apiRequest(
      'post1',
      Global.urls.SubcontractorManagement.saveSubBasic01MstU1,
      payload
    );
  }, options);
};
